import {
  Box as MuiBox,
  CircularProgress as MuiCircularProgress,
  useTheme,
} from '@mui/material';
import { Button, DeleteButton, Dialog } from 'components';
import { Typography } from 'components/ui';
import { useTranslation } from 'react-i18next';
import CancelButton from 'components/Buttons/CancelButton';
import TableUserInfo from 'components/TableUserInfo';
import useCheckBlockingOptions from 'lib/hooks/useCheckBlockingOptions';

const DeactivateDialog = (props) => {
  const { close, initialData } = props;
  const { t } = useTranslation();
  const theme = useTheme()
  const { user, isPatient } = initialData;

  const { checkBlockingObjects } = useCheckBlockingOptions(user.id);

  return (
    <Dialog
      {...props}
      maxWidth="sm"
      fullWidth
      title={initialData?.dialogTitle}
      onClose={close}
    >
      <Typography style={{ color: theme.palette.colors.gray400 }} mb={5}>
        {initialData?.dialogWarningMessage}
      </Typography>
      <MuiBox style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
        <TableUserInfo isPatient={isPatient} isActive user={user} isDialog />
      </MuiBox>
      <MuiBox
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '20px',
          gap: 10,
        }}
      >
        <CancelButton
          variant="outlined"
          onClick={() => close({ isDeleted: false })}
        />
        <DeleteButton
          style={{ height: 40 }}
          icon={false}
          onClick={() => {
            if (isPatient) {
              checkBlockingObjects(
                () => close({ ...initialData, isDeleted: true }),
                () => close({ isDeleted: false })
              );
            } else {
              close({ ...initialData, isDeleted: true });
            }
            // We're checking blocking objects only for patients for now, for practitioners error is returned.
          }}
          title={
            initialData?.loading ? (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                <MuiCircularProgress
                  style={{ width: '20px', height: '20px' }}
                />
              </div>
            ) : (
              t('Deactivate')
            )
          }
        />
      </MuiBox>
    </Dialog>
  );
};

export default DeactivateDialog;
